"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsDepartementMapTooltip", function(obsUtils) {
    return {
        restrict : "E",
        require  : "^obsDepartementManager",
        scope    : true,
        replace  : true,
        template : `
        <div class="leaflet-control control obs-map-tooltip">
            <div class="hovered-name">{{hoverName}}</div>
            <div class="hovered-value">
                {{referenceLabel}}: {{hoverValue}}
            </div>
        </div>`,
        link : function($scope, $el, $attrs, managerCtrl) {
            $scope.$watch(() => managerCtrl.getHoveredCommune(), (hoveredCommune) => {
                if(hoveredCommune == null) {
                    $scope.hoverName = null;
                    $scope.hoverValue = null;
                } else {
                    $scope.hoverName = hoveredCommune.nom;
                    $scope.hoverValue = obsUtils.formatValue($scope.communeParams, hoveredCommune.value);
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/departement/obsDepartementMapTooltip.js